import { AppStoreKind } from '@/app/_lib/interfaces';
import { useEffect, useRef, useState } from 'react';

export function useDomWatcher(
  callback: Function,
  skip?: boolean,
  targetSelector?: string
): React.RefObject<any> {
  const ref: React.RefObject<any> = useRef();
  useEffect(() => {
    if (skip) {
      return;
    }

    //@ts-ignore
    const handleClickOutside = (event) => {
      if (
        (ref.current && !ref.current.contains(event.target)) ||
        (targetSelector && !event.target.closest(targetSelector))
      ) {
        callback && callback();
      }
    };

    document.addEventListener('click', handleClickOutside, { capture: true });
    return () => {
      document.removeEventListener('click', handleClickOutside, {
        capture: true,
      });
    };
  }, [skip]);

  return ref;
}

export const useMediaQuery = (query: string) => {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const media = window.matchMedia(query);

    if (media.matches !== matches) {
      setMatches(media.matches);
    }

    const listener = () => setMatches(media.matches);

    window.addEventListener('resize', listener);

    return () => window.removeEventListener('resize', listener);
  }, [matches, query]);

  return matches;
};

export const useCurrentPlatform = (): AppStoreKind | undefined => {
  const [platform, setPlatform] = useState<AppStoreKind | undefined>();
  useEffect(() => {
    if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
      setPlatform('apple');
    } else if (navigator.userAgent.match(/Android/i)) {
      setPlatform('android');
    } else setPlatform('other');
  });
  return platform;
};
